import "./allPlantBatch.css";
import React, { useState, useEffect } from "react";
import {
  GET_ALL_PLANTATION,
  GET_USER_DETAILS,
  RescScmAdminMember,
  DELETE_PLANTATION,
  TOTAL_BAMBOO_GRAPH,
  BAMBOO_REGENERATION_GRAPH,
  FETCH_NEW_PLANTBATCH,
} from "../../../common/URLs";

import jwt from "jwt-decode";
import { loaderService } from "../../../common/custom-loader/loader-service";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import EditIcon from "../../../images/EditIcon.png";
import TrashIcon from "../../../images/TrashIcon.png";
import {
  Button,
  CardContent,
  Paper,
  Divider,
  Chip,
  IconButton,
  Link,
  Tabs,
  Tab,
} from "@mui/material";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PIT_ROLES, PROD, RESOURCE_ROLES } from "../../../common/constants";
import {
  Container,
  Stack,
  Typography,
  TextField,
  Grid,
  Box,
} from "@mui/material";
import { format } from "date-fns";
import { DataGrid } from "@mui/x-data-grid";
import BackButton from "../../../common/backButton";
import moment from "moment";
import {
  capitalizeFunction,
  emailUrnPassMaxLength,
} from "../../../common/commonValidations";
import { useTranslation } from "react-i18next";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { toast } from "react-toastify";
import ReactApexChart from "react-apexcharts";
import apiClient from "../../../axios";
import { ViewIcon } from "../../../common/icons";
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";

function AllPlantBatch() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();

  const [emailId, setEmailId] = useState();
  const [userId, setUserId] = useState();
  const [roles, setRoles] = useState();
  const [userDetails, setUserDetails] = useState();
  const [selectedUrn, setSelectedUrn] = useState(null);
  const [selectedPlantation, setSelectedPlantation] = useState(null);
  const [selectedBatchToView, setSelectedBatchToView] = useState(null);
  const [showBatchDetails, setShowBatchDetails] = useState(false);
  const [urnError, setUrnError] = useState("");
  const [plantationBatchError, setPlantationBatchError] = useState("");
  const [id, setId] = useState();
  const [urn, setUrn] = useState();
  const [getAllPlantationDetails, setGetAllPlantationDetails] = useState([]);
  const [plantBatchDetails, setPlantBatchDetails] = useState();
  const [deletePlantationResponse, setDeletePlantationResponse] = useState();
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  const [submitItem, setSubmitItem] = useState();
  const [totalBambooGraphData, setTotalBambooGraphData] = useState();
  const [regenerationBambooGraphData, setRegenerationBambooGraphData] =
    useState();

  const [activeTab, setActiveTab] = useState(state?.activeTab || "newRequest");

  let checkUserDetails = localStorage.getItem("role");

  const decodedToken = getLocalStorageItem("id_token")
    ? jwt(getLocalStorageItem("id_token"))
    : null;

  const isGrowerView = !!decodedToken?.extension_URN;

  useEffect(() => {
    if (deletePlantationResponse) {
      if (deletePlantationResponse?.status === "SUCCESS") {
        toast.success(deletePlantationResponse?.description);
      } else {
        toast.error(deletePlantationResponse?.description);
      }
      getAllPlantation(urn ? urn : selectedUrn, activeTab);
    }
  }, [deletePlantationResponse]);

  useEffect(() => {
    if (getLocalStorageItem("id_token")) {
      const decoded = jwt(getLocalStorageItem("id_token"));
      const email = decoded.emails?.[0];
      setEmailId(email);
    }
  }, []);

  useEffect(() => {
    if (emailId) {
      getUserDetails();
    }
  }, [emailId]);

  function getUserDetails() {
    apiClient
      .post(
        GET_USER_DETAILS,
        {
          emailAddress: emailId,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setUserDetails(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    if (getLocalStorageItem("id_token")) {
      const decoded = jwt(getLocalStorageItem("id_token"));
      if (decoded.extension_URN) {
        setUrn(decoded.extension_URN);
      }
    }
  }, []);

  useEffect(() => {
    // if (urn) {
    getAllPlantation(urn, activeTab);
    // }
  }, [urn, activeTab]);

  const getNewRequestPayload = (urnValue) => {
    return {
      urn: urnValue,
      plantBatchNo: selectedPlantation,
      allFlag: isGrowerView ? "N" : "Y",
    };
  };

  const getPayloadByTab = (urnValue, tabKey) => {
    const basePayload = {
      urn: urnValue,
      plantBatchNo: selectedPlantation,
    };

    if (isGrowerView) {
      if (tabKey === "matured") {
        return {
          ...basePayload,
          maturedFlag: "Y",
          allFlag: "N",
        };
      }

      if (tabKey === "immatured") {
        return {
          ...basePayload,
          maturedFlag: "N",
          allFlag: "N",
        };
      }

      return {
        ...basePayload,
      };
    }

    if (tabKey === "matured") {
      return {
        ...basePayload,
        maturedFlag: "Y",
      };
    }

    if (tabKey === "immatured") {
      return {
        ...basePayload,
        maturedFlag: "N",
      };
    }

    return {
      ...basePayload,
    };
  };

  function getAllPlantation(urnValue, tabKey = activeTab) {
    loaderService.showLoader();

    const isNewRequestTab = tabKey === "newRequest";
    const apiUrl = isNewRequestTab ? FETCH_NEW_PLANTBATCH : GET_ALL_PLANTATION;
    const payload = isNewRequestTab
      ? getNewRequestPayload(urnValue)
      : getPayloadByTab(urnValue, tabKey);

    apiClient
      .post(
        apiUrl,
        payload,
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setGetAllPlantationDetails(response.data || []);
        setSelectedBatchToView(null);
        setShowBatchDetails(false);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  function deletePlantation(item) {
    loaderService.showLoader();
    apiClient
      .post(
        DELETE_PLANTATION,
        { ...item, mainTableId: item.id, roleName: getLocalStorageItem("role") },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setDeletePlantationResponse(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  const onDeletePlantation = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    setSubmitItem(item);
    handleConfirmLogModalOpen();
  };

  const onGetPlantation = () => {
    if (selectedUrn || selectedPlantation) {
      getAllPlantation(selectedUrn || urn, activeTab);
      setUrnError("");
      setPlantationBatchError("");
    } else {
      setUrnError("Enter URN");
      setPlantationBatchError("Enter Plantation Batch No.");
      toast.error("Please Enter URN or Plantation Batch No. to get details!");
    }
  };

  function onConfirmCallBack() {
    handleConfirmLogModalClose();
    deletePlantation(submitItem);
  }

  function onCancelBack() {
    handleConfirmLogModalClose();
  }

  const onViewBatch = (plantationBatchNo) => {
    setSelectedBatchToView(plantationBatchNo);
    setShowBatchDetails(true);
  };

  const onBackToGrid = () => {
    setSelectedBatchToView(null);
    setShowBatchDetails(false);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setSelectedBatchToView(null);
    setShowBatchDetails(false);
  };

  const speciescoloum = [
    { field: "species", headerName: t("resource.species"), width: 130 },
    {
      field: "saplingType",
      headerName: t("resource.saplingType"),
      width: 150,
    },
    { field: "noOfClumps", headerName: t("reg.noOfClumps"), width: 140 },
    {
      field: "saplingQuantity",
      headerName: t("resource.saplingQuantity"),
      width: 150,
    },
    {
      field: "dateOfPlantation",
      headerName: t("resource.dateOfPlantation"),
      width: 160,
      renderCell: (params) => {
        return <>{format(new Date(params.row?.dateOfPlantation), "dd/MM/yyyy")}</>;
      },
    },
    {
      field: "maturedDate",
      headerName: t("resource.plantationMaturedDate"),
      width: 190,
      renderCell: (params) => {
        return (
          <>
            {params.row?.maturedDate
              ? format(new Date(params.row?.maturedDate), "dd/MM/yyyy")
              : null}
          </>
        );
      },
    },
    {
      field: "action",
      headerName: t("reg.actions"),
      width: 130,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const item = getAllPlantationDetails.find((obj) =>
          obj.species?.some(
            (hobbyObj) => JSON.stringify(hobbyObj) === JSON.stringify(params?.row)
          )
        );
        return (
          <Button
            variant="contained"
            size="small"
            onClick={() =>
              navigate("addPlantation", {
                state: { batchItem: item, speciesItem: params?.row, activeTab: activeTab, screen: "allPlantation" },
              })
            }
          >
            {getLocalStorageItem("role") === RESOURCE_ROLES?.ResPlantationManager || getLocalStorageItem('role') === RESOURCE_ROLES?.ModuleIncharge || getLocalStorageItem('role') === RESOURCE_ROLES?.PlantSCMMember
              ? "View"
              : `${t("reg.edit")}`}
          </Button>
        );
      },
    },
  ];

  const getTotalBambooGraph = () => {
    loaderService.showLoader();
    apiClient
      .post(
        TOTAL_BAMBOO_GRAPH,
        {},
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setTotalBambooGraphData(response.data.saplingAgeInMonthListPojo);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  const getRegenerationBambooGraph = () => {
    loaderService.showLoader();
    apiClient
      .post(
        BAMBOO_REGENERATION_GRAPH,
        {},
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setRegenerationBambooGraphData(response.data.bambooRegenerationInMonthPojo);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  const totalBambooGraph = {
    options: {
      title: {
        text: "Total Bamboo",
        align: "center",
      },
      legend: {
        show: true,
        showForSingleSeries: false,
        onItemClick: {
          toggleDataSeries: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        title: {
          text: "Age (in months)",
        },
        categories: totalBambooGraphData?.map((item) => item.saplingAgeInMonth),
      },
      yaxis: {
        title: {
          text: "Bamboo Poles",
        },
      },
      plotOptions: {
        bar: {
          distributed: true,
          horizontal: false,
          borderRadius: 4,
        },
      },
    },
    series: [
      {
        name: "Availability",
        data: totalBambooGraphData?.map((item) => item.totalBambooInThousand),
      },
    ],
  };

  const regenerationBambooGraph = {
    options: {
      title: {
        text: "Bamboo Regeneration factor",
        align: "center",
      },
      legend: {
        show: true,
        showForSingleSeries: false,
        onItemClick: {
          toggleDataSeries: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      chart: {
        type: "bar",
      },
      xaxis: {
        title: {
          text: "Age (in months)",
        },
        categories: regenerationBambooGraphData?.map((item) => item.month),
      },
      yaxis: {
        title: {
          text: "Bamboo Poles",
        },
      },
      plotOptions: {
        bar: {
          distributed: true,
          horizontal: false,
          borderRadius: 4,
        },
      },
    },
    series: [
      {
        name: "Availability",
        data: regenerationBambooGraphData?.map(
          (item) => item.bambooRegenerartion
        ),
      },
    ],
  };

  const plantationBatchSummaryColumns = [
    {
      field: "id",
      headerName: "S.No.",
      width: 60,
      sortable: false,
      filterable: false,
      renderCell: (params) => params.api.getRowIndex(params.row.id) + 1,
    },
    {
      field: "plantationBatchNo",
      headerName: t("resource.plantationBatchNo"),
      flex: 1,
      minWidth: 190,
      renderCell: (params) => (
        <Button
          variant="text"
          sx={{ textTransform: "none", fontWeight: 600 }}
          onClick={() => onViewBatch(params.row.plantationBatchNo)}
        >
          {params.value}
        </Button>
      ),
    },
    {
      field: "urn",
      headerName: t("resource.urn"),
      flex: 1,
      minWidth: 170,
      renderCell: (params) => {
        return (
          <Button
            sx={{ textTransform: "none", fontWeight: 600 }}
            to={params}
            onClick={() => {
              onView(params?.row?.urn, params?.row?.growerType);
            }}
          >
            {params.value}
          </Button>
        );
      },
    },
    {
      field: "name",
      headerName: t("pit.name"),
      flex: 1,
      minWidth: 180,
    },
    {
      field: "stateName",
      headerName: t("preReg.state"),
      flex: 1,
      minWidth: 150,
    },
    {
      field: "districtName",
      headerName: t("preReg.district"),
      flex: 1,
      minWidth: 170,
    },
    {
      field: "totalSpecies",
      headerName: "No. of Species",
      width: 120,
    },
    {
      field: "isMatured",
      headerName: "Is Mature",
      width: 90,
    },
    {
      field: "maturedDate",
      headerName: "Matured Date",
      width: 120,
      hide: activeTab !== "matured"
    },
    {
      field: "isApproved",
      headerName: "Approved for Harvesting",
      width: 130,
    },
    {
      field: "workflowStatus",
      headerName: "Status",
      width: 130,
    },
    {
      field: "workflowCurrentOwner",
      headerName: "Current Owner",
      width: 230,
    },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          size="small"
          variant="contained"
          color="primary"
          onClick={() => onViewBatch(params.row.plantationBatchNo)}
        >
          <ViewIcon />
        </IconButton>
      ),
    },
  ];

  const onView = (urnSelected, growerSubCategory) => {
    const userData = {
      urnSelected: urnSelected,
      isScrutinyView: true,
    };
    if (
      growerSubCategory === "Individual" ||
      growerSubCategory === "JFMC" ||
      growerSubCategory === "Other Agency"
    ) {
      navigate("/registrationHome/dashboard/registrationDetails", {
        state: { data: userData, URN: urnSelected, activeTab },
      });
    } else if (
      growerSubCategory === "Co-operative" ||
      growerSubCategory === "FPO" ||
      growerSubCategory === "SHG" ||
      growerSubCategory === "FPC"
    ) {
      navigate("/registrationHome/dashboard/registrationMemberDetails", {
        state: { data: userData, URN: urnSelected, activeTab },
      });
    } else if (growerSubCategory === "Forest") {
      navigate("/registrationHome/dashboard/registrationDetailsForest", {
        state: { data: userData, URN: urnSelected, activeTab },
      });
    }
  };

  const plantationBatchSummaryRows = getAllPlantationDetails?.map(
    (item, index) => ({
      id: index + 1,
      plantationBatchNo: item?.plantationBatchNo,
      urn: item?.urn,
      totalSpecies: item?.species?.length || 0,
      stateName: item?.stateName,
      districtName: item?.districtName,
      name: item?.growerName,
      isApproved: item?.isApproved === "Approved" ? "Yes" : "No",
      isMatured: item?.isMatured === "Y" ? "Yes" : "No",
      maturedDate: format(new Date(item?.maturedDate), "dd/MM/yyyy"),
      growerType: item?.growerType,
      workflowStatus: item?.workflowStatus,
      workflowCurrentOwner: item?.workflowCurrentOwner
    })
  );

  const plantationDetailsToShow = selectedBatchToView
    ? getAllPlantationDetails?.filter(
      (item) => item?.plantationBatchNo === selectedBatchToView
    )
    : [];

  const selectedBatchData = getAllPlantationDetails?.find(
    (item) => item?.plantationBatchNo === selectedBatchToView
  );

  return (
    <>
      <Container maxWidth="xxl" sx={{ py: 2 }}>
        {!PROD && <p className="pageNumberingResc">RES24</p>}

        <Paper
          elevation={0}
          sx={{
            p: 2,
            mb: 2,
            borderRadius: 3,
            border: "1px solid #e6e9ef",
            background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
          }}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            spacing={2}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <BackButton navigate={navigate} />
              <Box>
                <Typography variant="h5" fontWeight={700}>
                  {t("resource.viewPlantationBatch")}
                </Typography>
              </Box>
            </Stack>

            <Chip
              label={`Total Batches: ${getAllPlantationDetails?.length || 0}`}
              color="primary"
              variant="outlined"
            />
          </Stack>
        </Paper>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: 3,
                border: "1px solid #e6e9ef",
                overflow: "hidden",
              }}
            >
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  px: 2,
                  borderBottom: "1px solid #e6e9ef",
                  backgroundColor: "#f8fafc",
                }}
              >
                <Tab label="New Request" value="newRequest" />
                <Tab label="Matured" value="matured" />
                <Tab label="Immatured" value="immatured" />
              </Tabs>

              <Box sx={{ p: 2 }}>
                {getAllPlantationDetails.length > 0 ? (
                  <>
                    {!showBatchDetails && (
                      <Paper
                        elevation={0}
                        sx={{
                          borderRadius: 3,
                          border: "1px solid #e6e9ef",
                          overflow: "hidden",
                        }}
                      >
                        <Box
                          sx={{
                            px: 2,
                            py: 1.5,
                            backgroundColor: "#f8fafc",
                            borderBottom: "1px solid #e6e9ef",
                          }}
                        >
                          <Typography variant="subtitle1" fontWeight={700}>
                            Plantation Batch List
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Select a plantation batch to view its species details.
                          </Typography>
                        </Box>

                        <Box sx={{ height: 420, width: "100%" }}>
                          <DataGrid
                            rows={plantationBatchSummaryRows}
                            columns={plantationBatchSummaryColumns}
                            pageSize={10}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            disableSelectionOnClick
                            sx={{
                              border: 0,
                              "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#fafafa",
                                fontWeight: 700,
                              },
                              "& .MuiDataGrid-cell": {
                                alignItems: "center",
                              },
                            }}
                            components={{
                              Toolbar: QuickSearchToolbar,
                            }}
                          />
                        </Box>
                      </Paper>
                    )}

                    {showBatchDetails && selectedBatchToView && (
                      <>
                        <Paper
                          elevation={0}
                          sx={{
                            p: 2,
                            mb: 2,
                            borderRadius: 3,
                            border: "1px solid #e6e9ef",
                            backgroundColor: "#fcfcfd",
                          }}
                        >
                          <Stack
                            direction={{ xs: "column", md: "row" }}
                            justifyContent="space-between"
                            alignItems={{ xs: "flex-start", md: "center" }}
                            spacing={2}
                          >
                            <Box>
                              <Typography variant="h6" fontWeight={700}>
                                Plantation Batch Details
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                Showing species information for selected plantation batch.
                              </Typography>
                            </Box>

                            <Stack direction="row" spacing={1} flexWrap="wrap">
                              <Chip
                                label={`Batch No: ${selectedBatchData?.plantationBatchNo || "-"}`}
                                color="primary"
                                variant="outlined"
                              />
                              <Chip
                                label={`URN: ${selectedBatchData?.urn || "-"}`}
                                variant="outlined"
                              />
                              <Chip
                                label={`Species Count: ${selectedBatchData?.species?.length || 0}`}
                                variant="outlined"
                              />
                              <Button variant="outlined" onClick={onBackToGrid}>
                                Back to All Plantation Batches
                              </Button>
                            </Stack>
                          </Stack>
                        </Paper>

                        {plantationDetailsToShow.map((item, index) => {
                          return (
                            <Accordion
                              defaultActiveKey="0"
                              style={{ width: "100%", marginBottom: "16px" }}
                              key={item?.id || item?.plantationBatchNo || index}
                            >
                              <Card
                                style={{
                                  borderRadius: "16px",
                                  overflow: "hidden",
                                  border: "1px solid #e6e9ef",
                                  boxShadow: "0 2px 12px rgba(15, 23, 42, 0.04)",
                                }}
                              >
                                <Card.Header
                                  style={{
                                    background: "#f8fafc",
                                    borderBottom: "1px solid #e6e9ef",
                                    padding: "0px",
                                  }}
                                >
                                  <Accordion.Header
                                    variant="link"
                                    eventKey="0"
                                    style={{ width: "100%", padding: "0px" }}
                                  >
                                    <Box
                                      sx={{
                                        width: "100%",
                                        px: 2,
                                        py: 1.5,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: 2,
                                      }}
                                    >
                                      <Box>
                                        <Typography variant="subtitle1" fontWeight={700}>
                                          {t("resource.plantationBatch")}: {item?.plantationBatchNo}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                          URN: {item?.urn || "-"} | Total Species:{" "}
                                          {item?.species?.length || 0}
                                        </Typography>
                                      </Box>

                                      <img
                                        src={TrashIcon}
                                        style={{
                                          pointerEvents:
                                            plantationDetailsToShow?.[0]?.isApproved === "Approved" || getLocalStorageItem('role') === RESOURCE_ROLES?.ResPlantationManager || getLocalStorageItem('role') === RESOURCE_ROLES?.ModuleIncharge || getLocalStorageItem('role') === RESOURCE_ROLES?.PlantSCMMember
                                              ? "none"
                                              : "auto",
                                          opacity:
                                            plantationDetailsToShow?.[0]?.isApproved === "Approved" || getLocalStorageItem('role') === RESOURCE_ROLES?.ResPlantationManager || getLocalStorageItem('role') === RESOURCE_ROLES?.ModuleIncharge || getLocalStorageItem('role') === RESOURCE_ROLES?.PlantSCMMember
                                              ? 0.5
                                              : 2,
                                        }}
                                        onClick={(e) => onDeletePlantation(e, item)}
                                        alt="TrashIcon"
                                      />
                                    </Box>
                                  </Accordion.Header>
                                </Card.Header>

                                <Accordion.Body eventKey="0">
                                  <Card.Body style={{ padding: "16px" }}>
                                    <Box
                                      sx={{
                                        height: 320,
                                        width: "100%",
                                        borderRadius: 2,
                                        overflow: "hidden",
                                      }}
                                    >
                                      <DataGrid
                                        rows={item?.species || []}
                                        hideFooterPagination
                                        columns={speciescoloum}
                                        getRowId={(row) => row?.id}
                                        sx={{
                                          border: "1px solid #edf2f7",
                                          "& .MuiDataGrid-columnHeaders": {
                                            backgroundColor: "#fafafa",
                                          },
                                        }}
                                      />
                                    </Box>
                                  </Card.Body>
                                </Accordion.Body>
                              </Card>
                            </Accordion>
                          );
                        })}
                      </>
                    )}
                  </>
                ) : (
                  <Paper
                    elevation={0}
                    sx={{
                      p: 5,
                      borderRadius: 3,
                      border: "1px dashed #cbd5e1",
                      textAlign: "center",
                      backgroundColor: "#fafcff",
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight={700} mb={1}>
                      {t("resource.noDataAvailable")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      No plantation batch data is available for the current selection.
                    </Typography>
                  </Paper>
                )}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      <ConfirmationPopover
        onOpen={logConfirmModalOpen}
        onConfirm={onConfirmCallBack}
        onClose={onCancelBack}
        action="Delete"
      />
    </>
  );
}

export default AllPlantBatch;